<div class="contentModal">
  <h1 mat-dialog-title style="color: #3074AA;"><Strong>Cadastro de dispositivo para acesso ao Conectividade Social ICP</Strong></h1>
  <div mat-dialog-content #termo class="mat-typography">
 
   <mat-card class="card">
        <div [innerHTML]="innerHtml"></div>
    </mat-card>
  </div>
  <div mat-dialog-actions class="botoes">
    <button mat-raised-button class="md-icon-button btnNok" (click)="onClose()">
      <img class="img-fluid" src="assets/icons/white_close_icon.png"  width="16px"/> Fechar
    </button>
  </div>
</div>